import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI.js'
import PageTitleUI from '../../../widgets/output/PageTitleUI.js'
import SupportTemplateListSF from '../../../components/superUser/settings/SupportTemplateListSF.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'

const SupportTemplatePageUI = ({ context, rootTemplate, templateList,
  compList,onRefreshClick,
}) =>
  <SuperUserSettingsPageUI context={context} className='pg_su_doc' topnav='settings'
    headerText='Support Templates' centered={!rootTemplate} page='supTemplates'
  >
    {
      (!rootTemplate) &&
      <SpinnerComponentUI />
    }
    {
      rootTemplate &&
      <div>
        <PageTitleUI context={context}
          titleText='Support Templates' />

        <SupportTemplateListSF
          context={context}
          rootTemplate={rootTemplate}
          templateList={templateList}
          compList={compList}
          onRefreshClick={onRefreshClick}
        />
      </div>
    }
  </SuperUserSettingsPageUI>

export default SupportTemplatePageUI
